import { createTheme as t } from "../../_mixins/use-theme.js";
import r from "../../_styles/common/light.js";
import n from "../../popover/styles/light.js";
import m from "../../_internal/select-menu/styles/light.js";
function p(e) {
  const {
    boxShadow2: o
  } = e;
  return {
    menuBoxShadow: o
  };
}
const c = t({
  name: "Popselect",
  common: r,
  peers: {
    Popover: n,
    InternalSelectMenu: m
  },
  self: p
}), h = c;
export {
  h as default,
  p as self
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/popselect/styles/light.js
// module id = 471
// module chunks = 41